<script lang="ts">
    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import type { State } from "../../../../types/state";
    import { prettyJson } from "../../../../utils/utils";
    let state: Writable<State> = getContext("playerState");

    import Button from "./../../../shared/Button.svelte";
    import Icon from "./../../../shared/Icon.svelte";

    let shakaStats = "Please click refresh to load stats";

    $: sourceConfig = $state.sourceConfig;
    $: formattedSourceConfig = prettyJson($state.sourceConfig);

    $: playerConfig = $state.playerConfig;
    $: formattedPlayerConfig = prettyJson($state.playerConfig);

    function copyToClipboard(textToCopy: string) {
        navigator.clipboard
            .writeText(textToCopy ?? "N/A")
            .then(() => {
                console.log("Copied to the clipboard");
            })
            .catch(() => {
                console.warn("Failed to copy to the clipboard");
            });
    }

    function reloadStream() {
        if (!$state.sourceConfig) {
            return;
        }
        $state.adapter?.load($state.sourceConfig);
    }

    function refreshStats() {
        let stats = $state.adapter.player.getStats();
        let json = JSON.stringify(stats, null, 4);
        shakaStats = json;
    }
</script>

<div class="scotparl-misc-menu">
    <div class="misc-item">
        <div class="misc-item__label">
            <label for="">Manifest:</label>
        </div>
        <div class="misc-item-content">
            <Button
                disabled={!sourceConfig}
                on:click={() => copyToClipboard($state.adapter?.src)}
                label="Copy manifest URL to the clipboard"
            >
                <Icon type="contentCopy" disabled={!sourceConfig} />
            </Button>
            <Button
                disabled={!sourceConfig}
                label="Reload manifest"
                on:click={reloadStream}
            >
                <Icon type="replay" disabled={!sourceConfig} />
            </Button>
        </div>
    </div>

    <div class="misc-item">
        <div class="misc-item__label">
            <label for="">Source config:</label>
            <Button
                disabled={!sourceConfig}
                on:click={() => copyToClipboard(formattedSourceConfig)}
                label="Copy SourceConfig to the clipboard"
            >
                <Icon type="contentCopy" />
            </Button>
        </div>
        <div class="misc-item-content">
            <textarea readonly>{formattedSourceConfig}</textarea>
        </div>
    </div>
    <div class="misc-item">
        <div class="misc-item__label">
            <label for="">Player config:</label>
            <Button
                disabled={!playerConfig}
                on:click={() => copyToClipboard(formattedPlayerConfig)}
                label="Copy PlayerConfig to the clipboard"
            >
                <Icon type="contentCopy" disabled={!playerConfig} />
            </Button>
        </div>
        <div class="misc-item-content">
            <textarea readonly>
                {formattedPlayerConfig}
            </textarea>
        </div>
    </div>
    <div class="misc-item">
        <div class="misc-item__label">
            <label for="">Shaka stats: </label>
            <Button
                on:click={() => copyToClipboard(shakaStats)}
                label="Copy shaka stats"
            >
                <Icon type="contentCopy" />
            </Button>
            <Button on:click={refreshStats} label="Reload shaka stats">
                <Icon type="replay" />
            </Button>
        </div>
        <div class="misc-item-content">
            <textarea readonly>{shakaStats}</textarea>
        </div>
    </div>
</div>

<style lang="scss">
    .scotparl-misc-menu {
        textarea {
            margin: 0px;
            width: calc(100% - 2em);
            height: 209px;
            background-color: #ffffffcc;
            color: #1d1d1d !important;
            padding: 1em;
            text-shadow: 2px 2px 2px rgb(255 255 255 / 30%) !important;
        }

        .misc-item {
            padding-bottom: 1em;

            .misc-item__label {
                display: flex;
                align-content: center;
                align-items: center;
                height: 3em;
            }
            label {
                font-size: larger;
                display: inline-block;
            }
            .misc-item-content {
                display: flex;
                flex-wrap: wrap;
            }
        }
    }
</style>
